import { EstateOffer } from "@/types";
import { useLanguage } from "@/context/LanguageContext";

export function OfferInfoNewOrUpdated({ offer }: { offer: EstateOffer }) {
  const { language } = useLanguage();
  const copy = {
    cs: {
      updated: "Aktualizovaný",
      new: "Nový",
    },
    en: {
      updated: "Updated",
      new: "New",
    },
  }[language];

  return (
    <div>
      <span
        className={`absolute left-0 top-3 inline-block px-2 py-1 text-sm font-medium rounded-r-full transition-colors duration-200 ${
          offer.isUpdated
            ? "bg-softiq-primary-shade-600   text-softiq-secondary-shade-200"
            : "bg-softiq-secondary-shade-200  text-softiq-primary"
        }`}
      >
        {offer.isUpdated ? copy.updated : copy.new}
      </span>
    </div>
  );
}
